module.exports = __webpack_public_path__ + "media/images/web/header_courses-d5ea6afbd6cbf9edbc43f88fb9524e64.png";